<template>
    <div id="TabContract" class="table-responsive-sm">
       <section >
        <vue-good-table
              ref="listAssetTable"
              title="Asset"
              :columns="columns"
              :rows="rows"
              max-height="600px"
              :totalRows="totalRecords"
              :pagination-options="{
                  enabled: true,
                  position:'top',
                  mode: 'records',
                  perPage: 50,
                  perPageDropdown:[50,100],
                  dropdownAllowAll: false,
              }"
              :search-options="{
                  enabled: false,
                  placeholder: 'Search Asset',
              }"
              :select-options="{
                  enabled: false,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
              }"
              :sort-options="{
                  enabled: true,
              }">
              <div slot="emptystate">
                  No Data Found.
              </div>
              <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                      <template v-if="props.column.field == 'vehicle_name'">
                          <router-link class="color-blue" target="_blank" title="View Asset" v-bind:to="{name: 'ContractAssetView',params:{id:props.row.id}}">
                            {{ props.row.vehicle_name }}
                        </router-link>
                      </template>
                      <template v-else-if="props.column.field == 'section'">
                            <span>{{ props.row.section }}</span>
                      </template>
                      <template v-else>
                          {{props.formattedRow[props.column.field]}}
                      </template>
                  </div>
              </template>

          </vue-good-table>
      </section>
        <!-- <table aria-describedby="table" id="unit_table" class="table table-sm table-bordered font-1">
            <thead >
                <tr class="table-primary">
                    <th>Asset</th>
                    <th>Effective Date</th>
                    <th class="text-right">Term</th>
                    <th>Expiry Date</th>
                    <th class="text-right" v-for="(contractSectionData, index) in contractSectionArr" v-bind:key="index">{{ contractSectionData}}</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="assetArr != ''">
                    <tr v-for="(asset, index2) in assetArr" v-bind:key="index2">
                        <td v-fp-html="asset.vehicle_name"></td>
                        <td>{{ asset.effective_date }}</td>
                        <td class="text-right">{{ asset.term }}</td>
                        <td>{{ asset.expiry_date}}</td>

                        <template v-for="(SectionTitle,secId) in contractSectionArr">
                            <template v-if="asset.sections">
                                <template v-if="asset.sections[secId]">
                                    <template v-if="asset.sections[secId].id == secId ">
                                        <td class="text-right" v-bind:key="secId">{{ numberFormat(asset.sections[secId].value) }}</td>
                                    </template>
                                    <template v-else>
                                        <td class="text-right" v-bind:key="secId">-</td>
                                    </template>
                                </template>
                                <template v-else>
                                    <td class="text-right" v-bind:key="secId">-</td>
                                </template>
                            </template>
                            <template v-else>
                                <td class="text-right" v-bind:key="secId">-</td>
                            </template>
                        </template>
                    </tr>
                </template>
                <template v-else>
                    <tr>
                        <td class="text-center" colspan="5">{{"No Data Found!"}}</td>
                    </tr>
                </template>
            </tbody>
        </table> -->
    </div>
</template>
<script>

    export default {
        name: "TabContract",
        data: () => ({
            checkCol:true,
            role:"",
            assetArr: [],
            contractSectionArr: [],
            assetColumns:[],
            columns:[
                {
                    label: 'Asset',
                    field: 'vehicle_name',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Asset", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Effective Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Term',
                    field: 'term',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Term", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Expiry Date", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },
                {
                    label: 'Section',
                    field: 'section',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Section", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true

                },
            ],
            rows: [],
            totalRecords: 0,
        }),
        created: function() {

        },
        mounted: function() {

            var self = this;
            var path = window.location.pathname;
            var pathArr = path.split("/");

            self.tabContractData(pathArr[3]);

        },
        methods: {

            tabContractData(id){

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/tabcontract/search",
                    type: "GET",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: 'json',
                    data: {
                        id: id,
                    },
                    success: function (data) {
                        if (data.status == "success") {
                            // self.assetColumns = data.content.assetColumns;
                            self.rows = data.content.assets;
                            // console.log(self.assetColumns.length);
                            // for( var i = 0; i < data.content.assetColumns.length; i++){
                            //   self.assetColumns[i].filterOptions.filterFn = this.columnFilterFn;
                            // }
                            // self.assetArr = data.content.assets;
                            // self.contractSectionArr = data.content.sectionTitle;
                            // console.log(self.contractArr);
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.Registerbtn = "Register";
                        self.generateStatusCodeMessage(jqXHR,true,'contract-asset-tab-data')
                    }
                });

            },
            numberFormat(amount) {

                // var result = amount.replace(/[-+]?([0-9]*\.[0-9]+|[0-9]+)/);
                // return result;
                return parseFloat(amount).toFixed(2);

            },

        }
    };
</script>




// WEBPACK FOOTER //
// src/components/ContractAssetTabView.vue